<div class="sms">
    <form #smsConfigurationForm="ngForm" class="sms__form">
        <h5 class="bz-font-weight--semibold bz-space--stack-l">{{'ENVIRONMENT.SMS_CONFIGURATION' | translate}}</h5>
        <div class="sms__horizontal-section-space">
          <div class="sms__horizontal-section">
            <bzg-input class="sms__horizontal-section__input" [(ngModel)]="parameters.smsDefaultCountryCode"
                [max]="metadata['smsDefaultCountryCode'].max === -1 ? undefined : metadata['smsDefaultCountryCode'].max"
                [min]="metadata['smsDefaultCountryCode']?.min"
                [required]="metadata['smsDefaultCountryCode']?.required"
                placeholder="+ {{'ENVIRONMENT.COUNTRY_CODE' | translate}}" name="smsDefaultCountryCode"
                [type]="metadata['smsDefaultCountryCode']?.type"
                [pattern]="metadata['smsDefaultCountryCode']?.regex">
                {{'ENVIRONMENT.DEFAULT_COUNTRY_CODE' | translate}}
                <bzg-pattern-error>{{'ENVIRONMENT.ENTER_A_VALID_COUNTRY_CODE' | translate}}</bzg-pattern-error>
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                <bzg-max-error>{{ 'GLOBAL.INVALID_MAX_VALUE' | translate}} {{metadata['smsDefaultCountryCode'].max}}</bzg-max-error>
                <bzg-min-error>{{'GLOBAL.INVALID_MIN_VALUE' | translate}} {{metadata['smsDefaultCountryCode'].min}}</bzg-min-error>
            </bzg-input>
            <bzg-input class="sms__horizontal-section__input"
                [(ngModel)]="parameters.smsCodeValidityTimeInMinutes"
                [max]="metadata['smsCodeValidityTimeInMinutes'].max === -1 ? undefined : metadata['smsCodeValidityTimeInMinutes'].max"
                [min]="metadata['smsCodeValidityTimeInMinutes']?.min"
                [required]="metadata['smsCodeValidityTimeInMinutes']?.required"
                placeholder="{{'ENVIRONMENT.CODE_VALIDITY_PERIOD' | translate}}" name="smsCodeValidityTimeInMinutes"
                [type]="metadata['smsCodeValidityTimeInMinutes']?.type">
                {{'ENVIRONMENT.CODE_VALIDITY_PERIOD' | translate}}
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                <bzg-max-error>{{ 'GLOBAL.INVALID_MAX_VALUE' | translate}} {{metadata['smsCodeValidityTimeInMinutes'].max}}</bzg-max-error>
                <bzg-min-error>{{'GLOBAL.INVALID_MIN_VALUE' | translate}} {{metadata['smsCodeValidityTimeInMinutes'].min}}</bzg-min-error>
            </bzg-input>
          </div>
          <div class="sms__horizontal-section">
              <bzg-input [(ngModel)]="parameters.smsAttempts"
                  placeholder="{{'ENVIRONMENT.NUMBER_OF_CODES_ALLOWED' | translate}}"
                  [max]="metadata['smsAttempts'].max === -1 ? undefined : metadata['smsAttempts'].max"
                  [min]="metadata['smsAttempts']?.min"
                  [required]="metadata['smsAttempts']?.required"
                  class="sms__horizontal-section__input" name="smsAttempts"
                  [type]="metadata['smsAttempts']?.type">
                  {{'ENVIRONMENT.NUMBER_OF_CODES_ALLOWED' | translate}}
                  <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                  <bzg-max-error>{{ 'GLOBAL.INVALID_MAX_VALUE' | translate}} {{metadata['smsAttempts'].max}}</bzg-max-error>
                  <bzg-min-error>{{'GLOBAL.INVALID_MIN_VALUE' | translate}} {{metadata['smsAttempts'].min}}</bzg-min-error>
              </bzg-input>
              <bzg-input [(ngModel)]="parameters.smsTimeAfterMaxAttempts"
                  placeholder="{{'ENVIRONMENT.TIMEOUT_BETWEEN_CODE_REQUESTS' | translate}}"
                  [max]="metadata['smsTimeAfterMaxAttempts'].max === -1 ? undefined : metadata['smsTimeAfterMaxAttempts'].max"
                  [min]="metadata['smsTimeAfterMaxAttempts']?.min"
                  [required]="metadata['smsTimeAfterMaxAttempts']?.required"
                  class="sms__horizontal-section__input" name="smsTimeAfterMaxAttempts"
                  [type]="metadata['smsTimeAfterMaxAttempts']?.type">
                  {{'ENVIRONMENT.TIMEOUT_BETWEEN_CODE_REQUESTS' | translate}}
                  <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                  <bzg-max-error>{{ 'GLOBAL.INVALID_MAX_VALUE' | translate}} {{metadata['smsTimeAfterMaxAttempts'].max}}</bzg-max-error>
                  <bzg-min-error>{{'GLOBAL.INVALID_MIN_VALUE' | translate}} {{metadata['smsTimeAfterMaxAttempts'].min}}</bzg-min-error>
              </bzg-input>
          </div>
          <div class="sms__horizontal-section">
              <div class="sms__horizontal-section__select-container">
                  <strong>{{'ENVIRONMENT.PROVIDER' | translate}}</strong>
                  <bzg-select class="sms__horizontal-section__select" [placeholder]="'ENVIRONMENT.SELECT_BY' | translate"
                      [(value)]="parameters.smsPrincipalProvider">
                      <bzg-option>
                          {{'ENVIRONMENT.SELECT_BY' | translate}}
                      </bzg-option>
                      <bzg-option *ngFor="let provider of smsProviders" [value]="provider.name">
                          {{provider.displayName}}
                      </bzg-option>
                  </bzg-select>
              </div>
              <bzg-input class="sms__horizontal-section__input" [(ngModel)]="parameters.smsTwilioAccountSid"
                  [max]="metadata['smsTwilioAccountSid'].max === -1 ? undefined : metadata['smsTwilioAccountSid'].max"
                  [min]="metadata['smsTwilioAccountSid']?.min"
                  [required]="metadata['smsTwilioAccountSid']?.required"
                  placeholder="{{'ENVIRONMENT.ACCOUNT_SID' | translate}}" name="smsTwilioAccountSid"
                  [type]="metadata['smsTwilioAccountSid']?.type">
                  {{'ENVIRONMENT.ACCOUNT_SID' | translate}}
                  <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                  <bzg-max-error>{{ 'GLOBAL.INVALID_MAX_VALUE' | translate}} {{metadata['smsTwilioAccountSid'].max}}</bzg-max-error>
                  <bzg-min-error>{{'GLOBAL.INVALID_MIN_VALUE' | translate}} {{metadata['smsTwilioAccountSid'].min}}</bzg-min-error>
              </bzg-input>
          </div>
          <div class="sms__horizontal-section">
            <bzg-input class="sms__horizontal-section__input" [(ngModel)]="parameters.smsTwilioAuthToken"
                [max]="metadata['smsTwilioAuthToken'].max === -1 ? undefined : metadata['smsTwilioAuthToken'].max"
                [min]="metadata['smsTwilioAuthToken']?.min"
                [required]="metadata['smsTwilioAuthToken']?.required"
                placeholder="{{'ENVIRONMENT.AUTH_TOKEN' | translate}}" name="smsTwilioAuthToken"
                [type]="metadata['smsTwilioAccountSid']?.type">
                {{'ENVIRONMENT.AUTH_TOKEN' | translate}}
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                <bzg-max-error>{{ 'GLOBAL.INVALID_MAX_VALUE' | translate}} {{metadata['smsTwilioAuthToken'].max}}</bzg-max-error>
                <bzg-min-error>{{'GLOBAL.INVALID_MIN_VALUE' | translate}} {{metadata['smsTwilioAuthToken'].min}}</bzg-min-error>
            </bzg-input>
          </div>
          <div>
            <h5 class="bz-space--stack-m">{{'ENVIRONMENT.FROM_NUMBERS' | translate}}</h5>
            <form #smsAddNumberForm="ngForm" class="sms__add-number-form bz-space--inset-m bz-space--stack-m bz-border-radius--m bz-color-border--neutral-300">
                <bzg-input class="sms__add-number-form__input bz-space--inline-m"
                    [(ngModel)]="additionNumber.number"
                    [max]="metadata['smsDefaultCountryCode'].max === -1 ? undefined : metadata['smsDefaultCountryCode'].max"
                    [min]="metadata['smsDefaultCountryCode']?.min"
                    [required]="true"
                    placeholder="+ {{'ENVIRONMENT.TYPE_A_NUMBER' | translate}}"
                    name="addNumberInput"
                    [pattern]="SMS_NUMBER_REGEXP"
                    [hasCustomErrors]="numberAlreadyExists(additionNumber.number)">
                    {{'ENVIRONMENT.NUMBER' | translate}}
                    <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                    <bzg-pattern-error>{{'ENVIRONMENT.ENTER_A_VALID_NUMBER' | translate}}</bzg-pattern-error>
                    <!-- <bzg-custom-error>The number already exists</bzg-custom-error> -->
                    <bzg-max-error>{{ 'GLOBAL.INVALID_MAX_VALUE' | translate}} {{metadata['smsDefaultCountryCode'].max}}</bzg-max-error>
                    <bzg-min-error>{{'GLOBAL.INVALID_MIN_VALUE' | translate}} {{metadata['smsDefaultCountryCode'].min}}</bzg-min-error>
                </bzg-input>
                <div class="sms__horizontal-section__select-container">
                    <strong class="bz-space--stack-xs">{{'ENVIRONMENT.COUNTRY_CODES_ASSOCIATED' | translate}}</strong>
                    <bzg-select class="sms__add-number-form__input bz-space--inline-m" name="addNumberSelect"
                        multiple="true" placeholder="{{'ENVIRONMENT.SELECT_COUNTRIES' | translate}}..." [(value)]="additionNumber.countryCodesTo">
                        <bzg-option *ngFor="let country of countries" [value]="country">{{'ENVIRONMENT.' + country.countryName | translate}}</bzg-option>
                    </bzg-select>
                </div>
                <bzg-button-icon class="sms__add-number-form__button" [disabled]="isInvalidNumberToAdd()"
                    icon="icon-plus" [size]="'s'" [filled]="true" (click)="addNumber()">
                </bzg-button-icon>
            </form>
            <table class="sms__table bz-table bz-space--stack-xl">
                <thead>
                    <tr>
                    <th class="bz-table__cell bz-table__cell--sortable" *ngFor="let col of columns" [ngClass]="{'sms__table__column--small': col.key === 'isDefault' || col.key === 'actions'}">
                        <div class="bz-table__col-title" *ngIf="col.visible">
                        <span class="bz-space--inline-xs">{{ col.value | translate}}</span>
                        </div>
                    </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let smsNumber of smsTwilioFromNumbersArray; let i = index">
                    <td class="sms__table__radio-cell">
                        <bzg-radio-button [checked]="smsNumber.isDefault" (change)="selectDefault(i)"></bzg-radio-button>
                    </td>
                    <td class="bz-table__cell">
                        <div class="bz-table__cell-row">
                            <label *ngIf="editingRowIndex !== i">{{ smsNumber.number }}</label>
                            <bzg-input *ngIf="editingRowIndex === i" class="sms__add-number-form__input bz-space--inline-m"
                                [(ngModel)]="editModeNumber.number" [max]="metadata['smsDefaultCountryCode'].max === -1 ? undefined : metadata['smsDefaultCountryCode'].max"
                                [min]="metadata['smsDefaultCountryCode']?.min" [required]="true" placeholder="+Type a number"
                                name="editNumberInput" [type]="text" [pattern]="SMS_NUMBER_REGEXP" [isActive]="true">
                                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                                <bzg-pattern-error>{{'ENVIRONMENT.ENTER_A_VALID_NUMBER' | translate}}</bzg-pattern-error>
                                <bzg-max-error>{{ 'GLOBAL.INVALID_MAX_VALUE' | translate}} {{metadata['smsDefaultCountryCode'].max}}</bzg-max-error>
                                <bzg-min-error>{{'GLOBAL.INVALID_MIN_VALUE' | translate}} {{metadata['smsDefaultCountryCode'].min}}</bzg-min-error>
                            </bzg-input>
                        </div>
                    </td>
                    <td>
                        <div class="bz-table__cell-row">
                            <label *ngIf="editingRowIndex !== i">{{ getCommaSeparatedString(smsNumber.countryCodesTo) }}</label>
                            <bzg-select *ngIf="editingRowIndex === i" class="sms__add-number-form__input bz-space--inline-m" name="editNumberSelect"
                                multiple="true" placeholder="{{'ENVIRONMENT.SELECT_COUNTRIES' | translate}}..." [(value)]="editModeNumber.countryCodesTo" [isActive]="true">
                                <bzg-option *ngFor="let country of countries" [value]="country">{{'ENVIRONMENT.' + country.countryName | translate}}</bzg-option>
                            </bzg-select>
                        </div>
                    </td>
                    <td>
                        <div class="bz-table-options__right">
                            <bzg-button-icon *ngIf="editingRowIndex !== i" icon="icon-edit" (click)="startNumberEdition(smsNumber, i)"></bzg-button-icon>
                            <bzg-button-icon *ngIf="editingRowIndex === i" icon="icon-check-mark" [size]="'s'"
                                [filled]="true" (click)="finishNumberEdition(i)" [disabled]="isInvalidNumberForEdit()">
                            </bzg-button-icon>
                            <bzg-button-icon icon="icon-delete" (click)="onRemoveNumber(smsNumber)"></bzg-button-icon>
                        </div>
                    </td>
                    </tr>
                </tbody>
            </table>

          </div>
        </div>
    </form>
</div>
